// extracted by mini-css-extract-plugin
export default {"bodymain":"Main_bodymain__9HjpG","blockvideo":"Main_blockvideo__QZbzp"};